// src/pages/About.js
import React from "react";
import {
  Container,
  Typography,
  Box,
  Grid,
  Card,
  CardMedia,
  CardContent,
} from "@mui/material";

const About = () => {
  return (
    <Box>
      {/* Main Title with Full-Width Background Image */}
      <Box
        sx={{
          position: "relative",
          top: 0,
          left: 0,
          width: "98.9vw", // Full viewport width
          height: "40vh", // Full viewport height
          backgroundImage: "url(/about.jpg)",
          backgroundColor: "lavenderblush",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          overflow: "hidden", // Ensure no overflow
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "black",
          textAlign: "lcenter",
          zIndex: -1, // Ensure it's behind other content
        }}
      >
        <Box sx={{ textAlign: "center" }}>
          <Typography variant="h3" gutterBottom>
            About Us
          </Typography>
        </Box>
      </Box>

      {/* Spacing between sections */}
      <Box sx={{ my: 8 }}>
        <Container
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mb: 8,
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={6}>
              <Typography variant="h4" gutterBottom>
                Who Are We
              </Typography>
              <Typography variant="body1" paragraph>
                We are a group of passionate crocheters dedicated to creating
                unique and beautiful handcrafted items. Our story began with a
                love for the craft and a desire to share our creations with the
                world.
              </Typography>
              <Typography variant="h4" gutterBottom>
                A word from our Crocheter
              </Typography>
              <Typography variant="body1">
                Welcome to my cozy corner of creativity!
              </Typography>
              <Typography variant="body1" paragraph>
                Crocheting is more than just a hobby for me;it's a creative journey. 
                Every stitch, every yarn texture, every project tells a story 
                and brings something beautiful into the world. Every item you'll 
                find here is handmade with care and love. Whether you are looking 
                for a unique gift, a little comfort, r a piece to brighten up your 
                space, I hope you find something here that speaks to you. Thank you 
                for supporting handmade, your purchase helps keep this passion alive!
                
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <Card>
                <CardMedia
                  component="img"
                  height="300"
                  image="/passion.jpg" 
                  alt="My supplies"
                />
                <CardContent>
                  <Typography variant="h6">To our clients</Typography>
                  <Typography variant="body2" color="text.secondary">
                    Celebrate the elegance of handmade fashion
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* Why Choose Us Section */}
      <Box sx={{ textAlign: "center", mb: 8 }}>
        <Typography variant="h3" gutterBottom>
          Why Choose Us
        </Typography>
        <Typography variant="body1" paragraph>
          At Whimssical Stitches, we take pride in our craftsmanship and
          dedication to quality. Here are a few reasons why our customers choose
          us:
        </Typography>
        <Typography variant="body1" paragraph>
          - Unique, handcrafted items that stand out.
          <br />
          - High-quality materials and attention to detail.
          <br />
          - Exceptional customer service and support.
          <br />- A commitment to sustainable and ethical practices.
        </Typography>
      </Box>

      {/* 4 Good Things About Us */}
      <Container>
        <Grid container spacing={4}>
          <Grid item xs={12} sm={6} md={3}>
            <Box sx={{ textAlign: "center" }}>
              <Typography variant="h5" gutterBottom>
                High Quality
              </Typography>
              <Typography variant="body2">
                We use only the finest materials to ensure durability and
                comfort.
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Box sx={{ textAlign: "center" }}>
              <Typography variant="h5" gutterBottom>
                Unique Designs
              </Typography>
              <Typography variant="body2">
                Our products feature one-of-a-kind designs you won't find
                anywhere else.
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Box sx={{ textAlign: "center" }}>
              <Typography variant="h5" gutterBottom>
                Exceptional Service
              </Typography>
              <Typography variant="body2">
                We pride ourselves on providing top-notch customer support and
                service.
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Box sx={{ textAlign: "center" }}>
              <Typography variant="h5" gutterBottom>
                Ethical Practices
              </Typography>
              <Typography variant="body2">
                We follow sustainable and ethical practices in all aspects of
                our business.
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Container>

      {/* Product Images Section */}
      <Container>
        <Typography variant="h3" gutterBottom align="center" sx={{ mt: 5 }}>
          Our Products
        </Typography>
        <Grid container spacing={4}>
          <Grid item xs={12} sm={6} md={3}>
            <Card>
              <CardMedia
                component="img"
                height="140"
                image="/hexagon.jpeg"  
                alt="Product 1"
              />
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Card>
              <CardMedia
                component="img"
                height="140"
                image="/shawl.jpeg"  
                alt="Product 2"
              />
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Card>
              <CardMedia
                component="img"
                height="140"
                image="/rosebag.jpg" 
                alt="Product 3"
              />
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Card>
              <CardMedia
                component="img"
                height="140"
                image="/tulip.jpg"
                alt="Product 4"
              />
            </Card>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default About;
